exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-icon {\n  color: #2b2d31; }\n\n.big {\n  width: 24px;\n  height: 24px;\n  font-size: 24px; }\n\n.mid {\n  width: 18px;\n  height: 18px;\n  font-size: 18px; }\n\n.small {\n  width: 24px;\n  height: 24px;\n  font-size: 24px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-fuente-icon/negocios-fuente-icon.component.scss
// module id = ../../../../../src/app/components/negocios/negocios-fuente-icon/negocios-fuente-icon.component.scss
// module chunks = 0